import { render } from "./content-badge.vue?vue&type=template&id=276958c6"
import script from "./content-badge.vue?vue&type=script&lang=js"
export * from "./content-badge.vue?vue&type=script&lang=js"

import "./content-badge.vue?vue&type=style&index=0&id=276958c6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__